/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /**
   * WD Product Grid Item - Swatch Hover Effect
   *
   * Handles image swapping when hovering over custom color swatches.
   * When a user hovers over a swatch, the product image changes to show
   * the variant's featured image.
   */

  class WDProductGridSwatches {
    constructor() {
      this.init();
    }

    init() {
      // Find all product items with custom swatches
      const productItems = document.querySelectorAll('.product-item__custom-swatches');

      productItems.forEach((swatchesContainer) => {
        const productItem = swatchesContainer.closest('.product-item');
        if (!productItem) return;

        const productImage = productItem.querySelector(window.theme.isMobile() ? ".product-item-image-carousel.wd-mobile-only" : '[data-product-image-default]');
        if (!productImage) return;

        // Find all swatches in this container
        const swatches = swatchesContainer.querySelectorAll('[data-swatch-button]');

        swatches.forEach((swatch) => {
          const variantName = swatch.getAttribute('data-swatch-variant-name');
          const variantId = swatch.getAttribute('data-variant');

          if (!variantName && !variantId) return;

          // Handle mouseenter (hover start)
          swatch.addEventListener('mouseenter', (e) => {
            //WD CHANGE - Show sibling variant image if it is a sibling swatch -START
            const wdSwatch = swatch.getAttribute('data-wd-swatch');
            if (wdSwatch) {
              this.showSiblingVariantImage(productItem,e);
            }else{
              this.showVariantImage(productItem, variantName, variantId);
            }
            //WD CHANGE - Show sibling variant image if it is a sibling swatch -END
          });

          swatch.addEventListener('click', (e) => {
            //WD CHANGE - Redirect to sibling product if it is a sibling swatch -START
            const wdSwatch = swatch.getAttribute('data-wd-swatch');
            if (wdSwatch) {
              this.redirectToSiblingProduct(e);
            }else{
              this.showVariantImage(productItem, variantName, variantId, e);
            }
            //WD CHANGE - Redirect to sibling product if it is a sibling swatch -END
          });

          // Handle mouseleave (hover end)
          swatch.addEventListener('mouseleave', (e) => {
            //WD CHANGE - Hide sibling variant image if it is a sibling swatch -START
            const wdSwatch = swatch.getAttribute('data-wd-swatch');
            if (wdSwatch){
              this.hideSiblingVariantImage(productItem,e);
            }else{
              this.hideVariantImage(productItem);
            }
            //WD CHANGE - Hide sibling variant image if it is a sibling swatch -END
          });
        });
      });
    }

    /**
     * Show variant image on hover
     * @param {HTMLElement} productItem - The product item container
     * @param {string} variantName - The variant title/name
     * @param {string} variantId - The variant ID
     */
    showVariantImage(productItem, variantName, variantId, e) {
      const isMobile = window.theme.isMobile();
      const productImageSelector = isMobile ? ".product-item-image-carousel.wd-mobile-only" : '[data-product-image-default]';

      if (isMobile) {
        const swatchIndex = parseInt(e.target.getAttribute('data-swatch-index'));
        const productImageVariants = productItem.querySelectorAll('.product-item-image-carousel__slide');
        if (productImageVariants.length > 0) {
          productImageVariants[swatchIndex].scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        const productImage = productItem.querySelector(productImageSelector);
        const variantImages = productItem.querySelectorAll('.product-item__bg__inner');

        if (!productImage || variantImages.length === 0) return;

        // Find the matching variant image by variant title
        let targetImage = null;

        variantImages.forEach((imgContainer) => {
          const imgVariantTitle = imgContainer.getAttribute('data-variant-title');

          if (variantName && imgVariantTitle === variantName) {
            targetImage = imgContainer;
          }
        });

        if (!targetImage) return;

        // Hide all variant images first
        variantImages.forEach((img) => {
          img.classList.remove('is-visible');
        });

        // Show the target variant image
        targetImage.classList.add('is-visible');

        // Hide the default product image
        const defaultImage = productImage.querySelector('figure, img');
        if (defaultImage) {
          defaultImage.style.opacity = '0';
        }
      }
    }
    //WD CHANGE - Show sibling variant image if it is a sibling swatch -START
    showSiblingVariantImage(productItem, e) {
      const isMobile = window.theme.isMobile();
      const productImageSelector = isMobile ? ".product-item-image-carousel.wd-mobile-only" : '[data-product-image-default]';

      if (isMobile) {
        const swatchIndex = parseInt(e.target.getAttribute('data-swatch-index'));
        const productImageVariants = productItem.querySelectorAll('.product-item-image-carousel__slide');
        if (productImageVariants.length > 0) {
          productImageVariants[swatchIndex].scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        const productImage = productItem.querySelector(productImageSelector);
        const siblingImage = e.target.getAttribute('data-wd-swatch-sibling-image');

        if (!productImage || !siblingImage) return;



        // Find the matching variant image by variant title
        let targetImage = siblingImage;


        if (!targetImage) return;
        productImage.querySelectorAll ('img').forEach((img) => {
          img.setAttribute('src', targetImage);
          img.setAttribute("srcset", targetImage);
        });
      }
    }
    //WD CHANGE - Show sibling variant image if it is a sibling swatch -END
    //WD CHANGE - Redirect to sibling product if it is a sibling swatch -START
    redirectToSiblingProduct(e) {
        window.location.href = e.target.getAttribute('data-wd-swatch-sibling-product-url');
    }
    //WD CHANGE - Redirect to sibling product if it is a sibling swatch -END
    /**
     * Hide variant image and show default product image
     * @param {HTMLElement} productItem - The product item container
     */
    hideVariantImage(productItem) {
      const productImage = productItem.querySelector('[data-product-image-default]');
      const variantImages = productItem.querySelectorAll('.product-item__bg__inner');

      if (!productImage) return;

      // Hide all variant images
      variantImages.forEach((img) => {
        img.classList.remove('is-visible');
      });

      // Show the default product image
      const defaultImage = productImage.querySelector('figure, img');
      if (defaultImage) {
        defaultImage.style.opacity = '1';
      }
    }
    //WD CHANGE - Hide sibling variant image if it is a sibling swatch -START
    hideSiblingVariantImage(productItem, e) {
      const isMobile = window.theme.isMobile();
      const productImageSelector = isMobile ? ".product-item-image-carousel.wd-mobile-only" : '[data-product-image-default]';
      const productImage = productItem.querySelector(productImageSelector);
      const originalImage = e.target.getAttribute('data-wd-swatch-original-image');

      if (!productImage || !originalImage) return;

      productImage.querySelectorAll ('img').forEach((img) => {
        img.setAttribute('src', originalImage);
        img.setAttribute("srcset", originalImage);
      });
    }
    //WD CHANGE - Hide sibling variant image if it is a sibling swatch -END
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new WDProductGridSwatches();
    });
  } else {
    new WDProductGridSwatches();
  }

  // Re-initialize for dynamically loaded content (e.g., AJAX)
  document.addEventListener('shopify:section:load', () => {
    new WDProductGridSwatches();
  });


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
